import AddOrder from "../pages/AddOrder";
import Protected from "../components/Protected";

const routes = [
  {
    path: "/addOrder",
    element: (
      <Protected role="Add Order">
        <AddOrder />
      </Protected>
    ),
  },
];

export default routes;
